// extracted by mini-css-extract-plugin
export default {"shellInformations":"Informations_shellInformations__UGsrn","emphasisText":"Informations_emphasisText__UZeOG"};